import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import NewFeeInformation from "./NewFeeInformation";
import { getProductData } from "../../../utils/getUserUtility";

const landingId = "CF_CANCELATION_CONFIRMATION";

const onLoad = async ({ session, landedAt, uid, navigate }) => {
  console.log("load---->");
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;
  const product = products[0];

  const { itsMoreExpensive, newPremium, currenPremium } = prevForm.metadata;

  if (!itsMoreExpensive || !newPremium || !currenPremium)
    navigate(`/formulario/cancelacion/lealtad?uid=${uid}`);

  const productData = await getProductData(uid, product);

  const periods = {
    month: "mensual",
    "3month": "trimestral",
    "6month": "semestral",
    year: "anual",
  };

  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    currentLanding: landingId,
    itsMoreExpensive,
    newPremium,
    currenPremium,
    period: periods[productData.period],
    product: `${productData.brand} ${productData.model} ${
      productData?.year || ""
    }`,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <NewFeeInformation
    state={state}
    setState={setState}
    field={"CF_cancelation_confirmation_s21yh"}
  />
);

const nextPage = (props) => `/formulario/cancelacion/lealtad?uid=${props.uid}`;

const prevPage = (props) => `/formulario/cancelacion/no-gusto?uid=${props.uid}`;

const fieldsStructure = [];

const newFeeInformationProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default newFeeInformationProps;
